import { useMemo } from 'react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Absolute-position style from an annotation's percentage geometry. */
export function annotationStyle(a) {
  return {
    position: 'absolute',
    left: `${a.x}%`,
    top: `${a.y}%`,
    width: `${a.w}%`,
    height: `${a.h}%`,
    transform: a.rotation ? `rotate(${a.rotation}deg)` : undefined,
    transformOrigin: 'center center',
  };
}

export function signatureUrl(userId) {
  return `${API}/signatures/user/${userId}`;
}

/**
 * Read-only render of verification annotations (signatures / text / date) on top
 * of a form sheet. The parent must be position:relative. Font sizes use `cqw`
 * (container-query width units) so text scales identically on screen and on the
 * A4 print/PDF output.
 */
export default function VerificationOverlay({ verifications, exclude }) {
  const items = useMemo(() => {
    const list = [];
    (verifications || []).forEach((v) => {
      if (exclude && v.user_id === exclude) return;
      (v.annotations || []).forEach((a) => list.push({ a, userId: v.user_id }));
    });
    return list;
  }, [verifications, exclude]);

  if (items.length === 0) return null;

  return (
    <div
      className="verification-overlay"
      style={{ position: 'absolute', inset: 0, containerType: 'inline-size', pointerEvents: 'none', zIndex: 5 }}
      data-testid="verification-overlay"
    >
      {items.map(({ a, userId }) =>
        a.type === 'signature' ? (
          <img
            key={a.id}
            src={signatureUrl(userId)}
            alt="署名"
            style={{ ...annotationStyle(a), objectFit: 'contain' }}
          />
        ) : (
          <div
            key={a.id}
            style={{
              ...annotationStyle(a),
              fontSize: `${a.fontSize}cqw`,
              color: a.color,
              display: 'flex',
              alignItems: 'center',
              lineHeight: 1.15,
              whiteSpace: 'pre-wrap',
              fontWeight: 600,
              overflow: 'visible',
            }}
          >
            {a.value}
          </div>
        )
      )}
    </div>
  );
}
